import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';
import { StoreCatalogItem } from '../models';

const NEW_ARRIVALS_PAGE_SIZE = 8;

export function useNewArrivals(enabled: boolean, pageSize: number = NEW_ARRIVALS_PAGE_SIZE) {
  const [items, setItems] = useState<StoreCatalogItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!enabled) return;

    let active = true;
    setIsLoading(true);
    setError(null);

    storeService
      .getCatalog({
        pageNumber: 1,
        pageSize,
        sortBy: 'createdAt',
        sortDirection: 'desc',
      })
      .then((data) => {
        if (active) setItems(data.items);
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err : new Error('Erro ao carregar novidades'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [enabled, pageSize]);

  return { items, isLoading, error, isEmpty: items.length === 0 };
}
